import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

export const Reveal = ({ children, delay = 0, className = '' }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.6, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const PageHeader = ({ label, title, text, testId }) => (
  <Reveal className="mb-12">
    <p className="k-label mb-4">{label}</p>
    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#111] mb-5" data-testid={testId}>{title}</h1>
    {text && <p className="text-base md:text-lg text-[#5f6672] max-w-2xl leading-relaxed">{text}</p>}
  </Reveal>
);

export const Marquee = ({ items }) => {
  const list = (items || '').split('\n').map((s) => s.trim()).filter(Boolean);
  if (!list.length) return null;
  const doubled = [...list, ...list];
  return (
    <div className="overflow-hidden bg-[#111] text-white py-5" data-testid="marquee">
      <div className="k-marquee-track flex w-max gap-12 whitespace-nowrap">
        {doubled.map((t, i) => (
          <span key={i} className="font-display font-semibold text-lg flex items-center gap-12">
            {t}<span className="w-1.5 h-1.5 rounded-full bg-[#c9a36b]" />
          </span>
        ))}
      </div>
    </div>
  );
};

export const ProductCard = ({ product }) => (
  <Link
    to={`/producto/${product.product_id}`}
    className="group block bg-white rounded-xl overflow-hidden border border-[rgba(17,17,17,0.06)] hover:shadow-[0_20px_50px_rgba(17,17,17,0.08)] transition-shadow duration-300"
    data-testid={`product-card-${product.product_id}`}
  >
    <div className="aspect-[4/3] overflow-hidden bg-[#eef0f2]">
      {product.images?.[0] && (
        <img src={product.images[0]} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      )}
    </div>
    <div className="p-5">
      <div className="flex justify-between gap-3 mb-2">
        <h3 className="font-display font-semibold text-[17px] text-[#111] leading-snug">{product.name}</h3>
        <ArrowUpRight className="w-4 h-4 text-[#5f6672] shrink-0 group-hover:text-[#1b3352] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
      </div>
      <p className="text-sm text-[#5f6672] line-clamp-2 mb-4">{product.description}</p>
      <div className="flex justify-between items-center">
        <span className="font-display font-bold text-[#1b3352] text-lg">{product.price.toFixed(2).replace('.', ',')} €</span>
        <span className="font-mono-k text-[10px] tracking-[0.2em] uppercase text-[#7a5a2e]">{product.category}</span>
      </div>
    </div>
  </Link>
);
